import React, { Fragment } from "react";
import Assets from "./Assets";
import Basic from "./Basic";
import OpenGraph from "./OpenGraph";
import Schema from "./Schema";

const CommonHead = () => (
  <Fragment>
    <Assets />
    <Basic />
    <OpenGraph />
    <Schema />
  </Fragment>
);

export default CommonHead;
